import React from 'react';
import { C } from '../../shared/design-tokens.js';
import { formatDisplayName, statusBadge } from './directory-ui.js';

interface EmployeeCardProps {
  employee: Record<string, unknown> & { id: string | number };
  onClick?: (employee: Record<string, unknown> & { id: string | number }) => void;
}

export default function EmployeeCard({ employee, onClick }: EmployeeCardProps) {
  const badge = statusBadge(employee.status as string | null | undefined);
  const displayName = formatDisplayName(employee as { nickname?: string; first_name?: string; last_name?: string });

  return (
    <button
      type="button"
      onClick={() => onClick?.(employee)}
      style={{
        width: '100%',
        textAlign: 'left',
        padding: 12,
        borderRadius: 12,
        background: C.panel,
        border: `1px solid ${C.borderSoft}`,
        display: 'flex',
        gap: 12,
        alignItems: 'center',
        cursor: onClick ? 'pointer' : 'default',
        color: C.text,
      }}
    >
      <div style={{ width: 44, height: 44, borderRadius: '50%', overflow: 'hidden', border: employee.photo_url ? `2px solid ${C.gold}` : `2px solid ${C.red}`, flexShrink: 0 }}>
        {employee.photo_url ? (
          <img src={employee.photo_url as string} alt={displayName} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        ) : (
          <div style={{ width: '100%', height: '100%', background: 'rgba(255,255,255,0.05)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: C.textMuted, fontSize: 14 }}>
            {(String(employee.first_name || '?'))[0]}
          </div>
        )}
      </div>

      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ color: C.text, fontSize: 14, fontWeight: 600 }}>{displayName}</div>
        <div style={{ color: C.textMuted, fontSize: 12, marginTop: 2 }}>{String(employee.driver_id || 'No driver ID')} · {String(employee.role || 'No role')}</div>
        <div style={{ color: C.textMuted, fontSize: 12, marginTop: 2 }}>{String(employee.email || employee.phone || 'No contact info')}</div>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 6, alignItems: 'flex-end' }}>
        <span style={{ fontSize: 10, padding: '3px 8px', borderRadius: 999, background: badge.background, color: badge.color, textTransform: 'uppercase', letterSpacing: '0.08em' }}>
          {String(employee.status || 'unknown')}
        </span>
        <span style={{ fontSize: 10, padding: '3px 8px', borderRadius: 999, background: 'rgba(201,162,39,0.12)', color: C.gold }}>
          {String(employee.staffing_type || 'local')}
        </span>
      </div>
    </button>
  );
}
